import { StoreSchema } from '../../types/store'

export const selectModalType = (store: StoreSchema) => store.modal.modalType
export const selectModalData = (store: StoreSchema) => store.modal.data
